import { useMemo } from 'react';
import type { ResourceManagementPermissionsResponse } from 'api/resource-management/types';
import { FilterableField } from 'components/organisms/tasks/fields';
import { useProjectCustomFieldsAsFilterableFields } from './use-project-custom-fields-as-filterable-fields';
import { useProjectNativeFieldsAsFilterableFields } from './use-project-native-fields-as-filterable-fields';

export const useProjectFieldsAsFilterableFields = (
  {
    peopleIHaveAccessTo,
  }: { peopleIHaveAccessTo?: ResourceManagementPermissionsResponse } = {
    peopleIHaveAccessTo: undefined,
  },
): {
  loading: boolean;
  fields: FilterableField[];
} => {
  const { loading: customFieldsLoading, fields: customFields } =
    useProjectCustomFieldsAsFilterableFields();
  const { loading: nativeFieldsLoading, fields: nativeFields } =
    useProjectNativeFieldsAsFilterableFields({ peopleIHaveAccessTo });

  return useMemo(() => {
    let updatedNativeFields = nativeFields;

    // @amanrk28 TODO: remove startDateActual and dueDateActual from native fields after BE migration is done
    if (customFields?.some((field) => field.fieldName === 'startDateActual')) {
      updatedNativeFields = updatedNativeFields.filter(
        (field) => field.fieldName !== 'startDateActual',
      );
    }
    if (customFields?.some((field) => field.fieldName === 'dueDateActual')) {
      updatedNativeFields = updatedNativeFields.filter(
        (field) => field.fieldName !== 'dueDateActual',
      );
    }

    return {
      loading: customFieldsLoading || nativeFieldsLoading,
      fields: updatedNativeFields.concat(customFields),
    };
  }, [customFields, customFieldsLoading, nativeFields, nativeFieldsLoading]);
};
